import { Storage} from "../Utils";

export const MessageMixin ={
    data() {
        return {
            projectMessages: {},
        }
    },
    created() {
        this.setProjectMessage()
    },
    methods: {
        setProjectMessage() {
            Storage.getAllProjectMessages().forEach((m) => {
                this.projectMessages[m.projectType + "-" + m.step + "-" + m.key] = m.value;
            })
        },
        getMessage(step, key, project_type = 1) {
            if (Object.keys(this.$route.params).length) {
                const index = this.$route.params.index || 0
                this.project = Storage.getProject(index)
                project_type = this.project.type
            }

            const message = this.projectMessages[project_type + "-" + step + "-" + key];
            return message ? message : key;
        },
    }
}
